import React, { useCallback } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import LeadFinderSubscriptionPlan from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";
import { Alert, Button } from "@mapmycustomers/ui";

import { LEAD_FINDER_UPSELL_URL } from "@app/scene/map/utils/consts";
import { getLeadGenPlan, isCurrentUserOwner } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./LeadFinderPlanAlert.module.scss";

const messages = defineMessages({
  description: {
    id: "map.mapPoint.lead.annotation.alert.description",
    defaultMessage:
      "Get instant access to phone numbers, websites, business hours and {noPlan, select, true {more} other {3x the leads per search}}.",
    description: "Description for Lead Finder plan alert",
  },
  info: {
    id: "map.mapPoint.lead.annotation.alert.info",
    defaultMessage:
      "Ask your administrator if {noPlan, select, true {Lead Finder} other {upgrading}} is right for your team",
    description: "Extra info for non owner users",
  },
  inquire: {
    id: "map.mapPoint.lead.annotation.alert.inquire",
    defaultMessage: "Inquire",
    description: "Button title for inquiry",
  },
  title: {
    id: "map.mapPoint.lead.annotation.alert.title",
    defaultMessage:
      "Add this lead in one click with {noPlan, select, true {Lead Finder} other {Lead Finder Plus}}",
    description: "Title for Lead Finder plan alert",
  },
});

interface Props {
  isOwner: boolean;
  leadGenPlan?: LeadFinderSubscriptionPlan;
}

const LeadFinderPlanAlert: React.FC<Props> = ({ isOwner, leadGenPlan }) => {
  const intl = useIntl();
  const noPlan = leadGenPlan === LeadFinderSubscriptionPlan.NONE;

  const handleClick = useCallback(() => {
    window.open(LEAD_FINDER_UPSELL_URL, "_blank");
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.upperBody}>
        <div className={styles.info}>
          <span className={styles.title}>{intl.formatMessage(messages.title, { noPlan })}</span>
          <span className={styles.description}>
            {intl.formatMessage(messages.description, { noPlan })}
          </span>
        </div>
        {isOwner && (
          <Button onClick={handleClick} type="primary">
            {intl.formatMessage(messages.inquire)}
          </Button>
        )}
      </div>
      {!isOwner && (
        <Alert
          className={styles.alert}
          message={intl.formatMessage(messages.info, { noPlan })}
          showIcon
          type="info"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isOwner: isCurrentUserOwner(state),
  leadGenPlan: getLeadGenPlan(state),
});

export default connect(mapStateToProps)(LeadFinderPlanAlert);
